import { Component , Vue ,Prop,Watch} from "vue-property-decorator";
@Component
export default class blessingBagDetailModal extends Vue {
    @Prop() private roomData!: any;
    @Prop() private activityItem!: any;
    @Watch("params.awardType",{immediate:true,deep:true})
    onParamsChange(newVal:any,oldVal:any){
        this.itemSetFormatter()
    }
    params:any={
        baseId:'',//房间id
        sceneId:'',//场次id
        luckyName:'',//福袋活动名称
        durationTime:'3',//持续时间 
        durationTimeUnit:'m',//默认m  可以是 s （秒） 或者 m （分钟）
        awardType:'2',//奖项类型 1  优惠券 2 奖励金
        luckyCode:'',//活动号
        awardNum:'',//活动号奖项剩余数量
        luckyForm:'1',//参与形式  1  弹幕 默认1
        luckyTerm:'',//参与形式是1  输入的弹幕内容
        luckyWinners:'',//单场福袋中奖人数
        luckyTitle:'',//福袋展示文案
    }
    durationTime:any=''
    durationTimeVal:any='3'
    activityCodeData:any={}
    radio:any=3 // 持续时间
    isClick:boolean=true //是否可以点击
	api:any={
        createActivityApi: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/luckyBag/saveLuckyBag",//创建活动
        validateCodeApi: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/luckyBag/validateCode",//活动code校验
	}
	mounted() {
        if (this.activityItem.id) {
            this.params= JSON.parse(JSON.stringify(this.activityItem))
            this.params.awardType = this.params.awardType + ''
            this.durationTimeVal = this.params.durationTime = this.params.durationTime + ''
            if (this.params.durationTime!=3&&this.params.durationTime!=5&&this.params.durationTime!=10) {
                this.durationTimeVal = '-1'
                this.durationTime = this.params.durationTime
            }
        }else{
            this.params.baseId = this.$route.params.id
            this.params.sceneId = this.roomData.scene_id
        }
        
	}
    inspect(){//数据检查
        if (!this.params.luckyName) {
            this.$toast("请输入活动名称")
            return false
        }
        if ((this.durationTimeVal<0) && !this.durationTime) {
            this.$toast("请输入活动持续时间")
            return false
        }else if (this.durationTimeVal<0 && this.durationTime) {
            this.params.durationTime = this.durationTime
        }else{
            this.params.durationTime = this.durationTimeVal
        }
        if (!this.params.luckyCode) {
            this.$toast("请输入活动编号")
            return false
        }
        if (!this.params.luckyWinners) {
            this.$toast("请设置中奖人数")
            return false
        }
        if (!this.params.luckyTerm) {
            this.$toast("请设置评论内容")
            return false
        }
        // if (!this.params.luckyTitle) {
        //     this.$toast("请设置福袋展示文案")
        //     return false
        // }
        if (!this.params.awardNum) {
            this.$toast("请检查活动code是否有误")
            return false
        }
        return true
    }
    durationTimeMatter(){//持续时间输入判断
        if (this.durationTime) {
            this.durationTime = this.durationTime.replace(/\D/g,'')/1
            if(this.durationTime<0) {
                this.durationTime = 1
            }
            if(this.durationTime>60) {
                this.durationTime = 60
            }
        }
    }
    formatter(params:any,type:string){//中奖人数输入判断
        let str = params[type]
        if (!str) {
            params[type] = ''
            return false
        }
        str=str.replace(/\D/g,'')/1
        if (str<0) {
            str=0
        }
        params[type] = str + ''
    }
    itemSetFormatter(){//code设置校验
        if (!this.params.luckyCode) {
            this.activityCodeData = {}
            this.params.awardNum=''
            this.params.awardTotal=''
            return false
        }
        let url = `${this.api.validateCodeApi}?baseId=${this.params.baseId}&sceneId=${this.params.sceneId}&awardType=${this.params.awardType}&luckyCode=${this.params.luckyCode}`
        this.fetch({
            url: url,
            method: "get",
        }).then((res:any) => {
            this.activityCodeData = res
            this.params.awardNum = res.awardNum
            this.params.awardTotal = res.awardTotal
            this.$forceUpdate()
        }).catch((err:any)=>{
            this.activityCodeData = {}
            this.params.awardNum=''
            this.params.awardTotal=''
            this.$toast({message:err.msg,duration:5000})
        })	
    }
    close(query:boolean){
        this.$emit('closeDetail',query)
    }
    releaseActivity(){//修改/发布福袋活动
        if (this.inspect()) {
            if (!this.isClick) {
                this.$toast("正在发布，请不要重复提交")
                return false
            }else{
                this.isClick = false
            }
            this.fetch({
                url: this.api.createActivityApi,
                data:this.params,
                method: "post",
                // headers: {
                //     'Content-Type': 'application/json'
                // },
                noQS:true,
                formJson:true
            }).then((res:any) => {
                this.$toast("发布成功")
                this.isClick = true
                this.close(true)
            }).catch((err:any)=>{
                this.isClick = true
                this.$toast({message:err.msg,duration:5000})
            })		
        }
    }
}
